<template>
  <div>
    <main-header-plat-a />
    <div style="position: relative">
      <main-header-plat-b :navBItems="navBItems" />
    </div>
    <a class="black--text">Solicitadas</a>
  </div>
</template>

<script>
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';

export default {
  name: 'ProAppointmentsBPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
  },
  data() {
    return {};
  },
};
</script>
